import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import classnames from "classnames";
import { InteractiveList } from "@circle-react-shared/InteractiveList";
import { OptionsDropdownItemContent } from "./OptionsDropdownItemContent";

export interface OptionsDropdownProps extends ComponentPropsWithRef<"div"> {
  direction?: "up" | "down";
  items: any[];
  loading?: boolean;
  notFoundContent?: React.ReactNode | string;
  onSelect: (item: any) => void;
}

export const OptionsDropdown = forwardRef<HTMLDivElement, OptionsDropdownProps>(
  (
    {
      items,
      onSelect,
      loading,
      notFoundContent,
      direction,
      ...rest
    }: OptionsDropdownProps,
    ref,
  ) => (
    <div
      ref={ref}
      className={classnames("select-list bg-primary", `direction-${direction}`)}
      {...rest}
    >
      <InteractiveList
        subsectionKey=""
        loading={loading || false}
        getKey={item => item.value}
        getItemContent={OptionsDropdownItemContent}
        items={items}
        onSelect={onSelect}
        notFoundContent={notFoundContent as string}
      />
    </div>
  ),
);

OptionsDropdown.displayName = "OptionsDropdown";
